import React from 'react';
import styled from 'styled-components';
import installSolar from '../assets/install-solar.jpg';
import installSolar2 from '../assets/solar.jpg';
import installSolar3 from '../assets/project3.jpg';

const ServicesSection = () => {
  return (
    <SectionContainer id="about-section">
      <BackgroundShapes />
      <ContentHeader>
        <Eyebrow>O que fazemos</Eyebrow>
        <SectionTitle>Soluções completas em energia solar</SectionTitle>
        <SectionSubtitle>
          Da análise de viabilidade ao pós-venda, entregamos projetos com engenharia de ponta e atendimento próximo.
        </SectionSubtitle>
      </ContentHeader>
      <ServicesGrid>
        <ServiceCard>
          <ServiceImageWrapper>
            <ServiceIcon src={installSolar2} alt="Instalação" />
            <ServiceBadge>Projeto & Instalação</ServiceBadge>
          </ServiceImageWrapper>
          <ServiceTitle>Instalação de Painéis Solares</ServiceTitle>
          <ServiceDescription>
            Engenharia completa para sistemas eficientes, seguros e compatíveis com o seu consumo.
          </ServiceDescription>
        </ServiceCard>
        <ServiceCard>
          <ServiceImageWrapper>
            <ServiceIcon src={installSolar} alt="Manutenção" />
            <ServiceBadge>Operação segura</ServiceBadge>
          </ServiceImageWrapper>
          <ServiceTitle>Manutenção</ServiceTitle>
          <ServiceDescription>
            Monitoramento contínuo e suporte especializado para manter a performance do sistema.
          </ServiceDescription>
        </ServiceCard>
        <ServiceCard>
          <ServiceImageWrapper>
            <ServiceIcon src={installSolar3} alt="Consultoria" />
            <ServiceBadge>Consultoria estratégica</ServiceBadge>
          </ServiceImageWrapper>
          <ServiceTitle>Consultoria Energética</ServiceTitle>
          <ServiceDescription>
            Estudos personalizados para maximizar economia e acelerar o retorno do investimento.
          </ServiceDescription>
        </ServiceCard>
      </ServicesGrid>
    </SectionContainer>
  );
};

export default ServicesSection;

// Styled Components

const SectionContainer = styled.section`
  padding: 90px 20px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  position: relative;
  overflow: hidden;

  @media (min-width: 900px) {
    padding: 120px 20px;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -50%;
    right: -50%;
    height: 100%;
    background: rgba(255, 255, 255, 0.03);
    transform: skewY(-4deg);
    z-index: 0;
  }
`;

const BackgroundShapes = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  &::before, &::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colors.primary};/* Cor laranja translúcida */
    border-radius: 50%;
    z-index: -1;
    animation: float 6s ease-in-out infinite;
  }

  &::before {
    width: 400px;
    height: 400px;
    top: -150px;
    left: -200px;
    animation-duration: 10s;
  }

  &::after {
    width: 300px;
    height: 300px;
    bottom: -100px;
    right: -150px;
    animation-duration: 8s;
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(30px);
    }
    100% {
      transform: translateY(0);
    }
  }
  
  @media (max-width: 768px) {
    &::before {
      width: 200px;
      height: 200px;
      top: -100px;
      left: -100px;
    }
    &::after {
      width: 180px;
      height: 180px;
      bottom: -80px;
      right: -80px;
    }
  }
`;

const ContentHeader = styled.div`
  max-width: 900px;
  margin: 0 auto 60px;
  text-align: center;
  position: relative;
  z-index: 1;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  padding: 6px 16px;
  border-radius: 999px;
  background: rgba(255, 199, 0, 0.12);
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 3vw, 3rem);
  margin: 16px 0 12px;
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
  z-index: 1;
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.6;
  margin: 0;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 32px;
  position: relative;
  z-index: 1;
`;

const ServiceCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  padding: 28px;
  border-radius: 24px;
  box-shadow: 0px 20px 45px rgba(0, 0, 0, 0.2);
  text-align: left;
  transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.08);

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.08);
  }
`;

const ServiceImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  margin-bottom: 22px;
`;

const ServiceIcon = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  transition: all 0.3s ease;

  ${ServiceCard}:hover & {
    transform: scale(1.1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

const ServiceBadge = styled.span`
  position: absolute;
  left: 16px;
  bottom: 16px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(11, 15, 26, 0.85);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
`;

const ServiceTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.secondary};
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.6;
`;
